module.exports = __webpack_public_path__ + "static/img/bg_image3.99ce9f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_barocare/bg_image3.jpg
// module id = KlxR
// module chunks = 0